<template>
  <div>
    <!--    <div style="background-color: rgb(232,232,232);">-->
    <!--      <div class="row m-0 col-10 mx-auto">-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button-active">-->
    <!--            Работники-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button"><router-link to="/map">-->
    <!--            Добавление Работника-->
    <!--          </router-link></span>-->
    <!--        </div>-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button"><a @click="back">-->
    <!--            Назад-->
    <!--          </a></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="row col-11 mx-auto">-->
    <!--      <div class="col">-->
    <!--        <section class="p-2 col-md-8 mx-auto">-->
    <!--          <h2 class="text-center my-4">Работники</h2>-->
    <!--          <div class="list-group">-->
    <!--            <a href="#" class="list-group-item list-group-item-action own-list-item"-->
    <!--               v-for="man in deliveryMans" :key="man.id">-->
    <!--              {{ man.full_name }}-->
    <!--            </a>-->
    <!--          </div>-->
    <!--        </section>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="d-flex justify-content-center mb-3">
      <div class="nav">
        <button class="refresh-button mr-3" @click="filterByKey(activeFilter)">Обновить</button>
        <button :class="{ shad: activeFilter === filters[0] }" @click="filterByKey(filters[0])">Все</button>
        <!--<button href="" style="background: #FFC1F5" @click="filterByKey('is_working', 0)">Активные</button>-->
        <button class="inactive" :class="{ shad: activeFilter === filters[1] }" @click="filterByKey(filters[1])">
          Неактивные
        </button>
        <button class="working" :class="{ shad: activeFilter === filters[2] }" @click="filterByKey(filters[2])">
          На смене
        </button>
        <!--<a href="" style="background: #C1DEF7" @click="filterByKey('id', 3)">С заказами</a>-->
        <!--<a href="" style="background: #FFECEC" @click="filterByKey('id', 3)">Архив</a>-->
        <button class="deleted" :class="{ shad: activeFilter === filters[3] }" @click="filterByKey(filters[3])">
          Удаленные
        </button>
      </div>
    </div>

    <div class="table">
      <div class="table-container">
        <table class="tableText">
          <tr class="table-header">
            <td>id</td>
            <td>ФИО</td>
            <td>Телефон</td>
            <td>Действие</td>
          </tr>
          <tr v-for="man in filteredDeliveryMans" :key="man.id" :class="getManClass(man)">
            <td>{{ man.id }}</td>
            <td>{{ man.full_name }}</td>
            <td>{{ man.phone }}</td>
            <td>
              <button @click="showModal(man)">Управлять</button>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="guestinfo" v-if="isModalShowing">
      <div class="overlay" @click="isModalShowing = false"></div>
      <div class="visible_msg">
        <div id="endcontent" class="content">
          <section class="px-3">
            <div class="logo">
              <h2>{{ managingMan.full_name }}</h2>
              <button @click="isModalShowing = false" style="margin-left: auto;">Закрыть</button>
            </div>
            <div>
              <h4>Телефон: {{ managingMan.code }}</h4>
              <h4>Количество доставленных заказов: {{ managingMan.orders_count }}</h4>
              <h4>Сейчас на смене?
                <span v-if="managingMan.is_working">Да</span>
                <span v-else>Нет</span>
              </h4>
              <div v-if="managingMan.is_working">
                <h4>Количество текущих заказов: {{ managingMan.active_orders_count }}</h4>
                <h4>Длительность текущей смены: {{ managingMan.shift_duration }}</h4>
              </div>
              <h4>Последняя активность: {{ managingMan.last_seen }}</h4>
              <h4>Удален:
                <span v-if="managingMan.is_deleted_here">Да</span>
                <span v-else>Нет</span>
              </h4>
              <div class="my-4 d-flex justify-content-between align-items-center" v-if="!managingMan.is_deleted_here">
                <button class="delete-button" @click="isConfirmationShowing = true">Удалить Работника</button>
                <h4 v-if="isConfirmationShowing" class="m-0">Вы уверены?
                  <button class="delete-button" @click="deleteMan(managingMan)">Да</button>
                  <button class="delete-button-no" @click="isConfirmationShowing = false">Нет</button>
                </h4>
              </div>
              <div class="my-4 d-flex justify-content-between align-items-center" v-if="managingMan.is_deleted_here">
                <button class="delete-button" @click="isConfirmationShowing = true">Восстановить Работника</button>
                <h4 v-if="isConfirmationShowing" class="m-0">Вы уверены?
                  <button class="delete-button" @click="restoreMan(managingMan)">Да</button>
                  <button class="delete-button-no" @click="isConfirmationShowing = false">Нет</button>
                </h4>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DeliveryMans',
  data() {
    return {
      deliveryMans: [],
      filteredDeliveryMans: [],
      managingMan: null,
      isModalShowing: false,
      isConfirmationShowing: false,
      filters: [
        { key: 'id', value: -1, isLess: false, exceptDeleted: false },
        { key: 'is_working', value: 1, isLess: true, exceptDeleted: true },
        { key: 'is_working', value: 0, isLess: false, exceptDeleted: true },
        { key: 'is_deleted_here', value: 0, isLess: false, exceptDeleted: false },
      ],
      activeFilter: null,
    };
  },
  methods: {
    back() {
      history.back();
    },
    async filterByKey(filter) {
      this.activeFilter = filter;
      await this.updateMans();
      if (filter.isLess) {
        this.filteredDeliveryMans = this.deliveryMans
          .filter(man => man[filter.key] < filter.value && man.is_deleted_here === !filter.exceptDeleted);
      } else {
        this.filteredDeliveryMans = this.deliveryMans
          .filter(man => man[filter.key] > filter.value);
      }
    },
    getManClass(man) {
      if (man.is_deleted_here) {
        return 'deleted';
      }
      if (man.is_working) {
        return 'working';
      }
      return 'inactive';
    },
    showModal(man) {
      axios
        .post(`//${window.location.host}/api/v1/man-info`, {
          merchantHash: this.$store.state.merchantHash,
          restId: this.$store.state.restId,
          manId: man.id,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          this.managingMan = response.data.data[0];
          this.isModalShowing = true;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    deleteMan(man) {
      axios
        .post(`//${window.location.host}/api/v1/man-delete`, {
          merchantHash: this.$store.state.merchantHash,
          restId: this.$store.state.restId,
          manId: man.id,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          this.managingMan.is_deleted_here = true;
          this.deliveryMans.find(_man => _man.id === man.id).is_deleted_here = true;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      this.isConfirmationShowing = false;
    },
    restoreMan(man) {
      axios
        .post(`//${window.location.host}/api/v1/man-restore`, {
          merchantHash: this.$store.state.merchantHash,
          restId: this.$store.state.restId,
          manId: man.id,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          this.managingMan.is_deleted_here = false;
          this.deliveryMans.find(_man => _man.id === man.id).is_deleted_here = false;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      this.isConfirmationShowing = false;
    },
    async updateMans() {
      await axios
        .post(`//${window.location.host}/api/v1/mans`, {
          merchantHash: this.$store.state.merchantHash,
          restId: this.$store.state.restId,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          this.deliveryMans = response.data.data;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
  },
  watch: {
    isModalShowing(val) {
      if (!val) {
        this.isConfirmationShowing = false;
      }
    },
  },
  mounted() {
    this.activeFilter = this.filters[0];
    const vueComponent = this;
    this.updateMans().then(() => {
      vueComponent.filteredDeliveryMans = vueComponent.deliveryMans;
    });
    setInterval(this.filterByKey, 1000 * 60, this.activeFilter);
  },
};
</script>

<style scoped>
  .nav a, .nav button, .nav .mb {
    border: 2px solid #E3E7EC;
    padding: 7px 16px;
    /*background: #E3E7EC;*/
    border-radius: 4px;
    line-height: 18px;
    font-size: 15px;
    text-decoration: none;
    /*color: #7E8A97;*/
  }

  .delete-button {
    border-radius: 4px;
    line-height: 18px;
    font-size: 15px;
    text-decoration: none;
    padding: 12px 18px;
    background: #27BB62;
    border: none;
    color: white;
  }

  .delete-button-no {
    border-radius: 4px;
    line-height: 18px;
    font-size: 15px;
    text-decoration: none;
    padding: 12px 18px;
    border: none;
    color: white;
    background: #d94848;
  }

  .nav .shad {
    border: 2px solid #27BB62;
  }

  .inactive {
    background: #FEFFC4;
  }

  .working {
    background: #DEFFEA;
  }

  .deleted {
    background: #DCE1E4;
  }

  .refresh-button {
    padding: 12px 18px;
    background: #27BB62;
    border: none !important;
    outline: none;
    border-radius: 4px;
    font-size: 16px;
    color: white;
    text-decoration: none;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DeliveryMans.vue